export default __webpack_public_path__ + "media/vendors/google_play_download-607a3f00.svg";